import React from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import { I18n } from '@lingui/react';
import { t } from '@lingui/macro';
import '../../styles/core.scss';
import css from './action-button.scss';
import Text from './action-button-text';


const ActionButton =
({
    availableClassId,
    moveCopyDisableButton,
    executeMoveCommand, executeCopyCommand, isIE11, selectedClassId
}) => {
    const availableClassIdInt = parseInt(availableClassId, 10);
    const selectedClassIdInt = parseInt(selectedClassId, 10);
    return (<div className={`${css['action-button-holder']} ${isIE11 ? css.ie11 : null}`}>
        <I18n>
            {({ i18n }) => (
                <div className={`${css.btn}`}>
                    <button
                        onClick={() => { executeMoveCommand(); }}
                        className={`btn btn--primary ${css.play} ${moveCopyDisableButton() ? css.disabled : ''}`}
                        disabled={moveCopyDisableButton()}
                        title={i18n._(t('moveButton.title')`${Text.MoveText}`)}
                    />
                    <button
                        onClick={() => { executeCopyCommand(); }}
                        className={`btn btn--primary ${css.default} ${moveCopyDisableButton() ? css.disabled : ''}`}
                        hidden={availableClassIdInt === 0 || availableClassIdInt === selectedClassIdInt}
                        title={i18n._(t('copyButton.title')`${Text.CopyText}`)} >{Text.Copy} &gt;
                    </button>
                </div>
            )}
        </I18n>
    </div>);
};

ActionButton.propTypes = {
    availableClassId: PropTypes.number,
    selectedClassId: PropTypes.number,
    moveCopyDisableButton: PropTypes.func,
    executeMoveCommand: PropTypes.func,
    executeCopyCommand: PropTypes.func,
    isIE11: PropTypes.bool
};

export default styleable(css)(ActionButton);



// WEBPACK FOOTER //
// ./components/action-button/action-button.js